import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { setSelectedTeamMember } from '../../store/slices/common';
import { createTeamMember, updateTeamMember } from '../../store/slices/api/inner/TeamMemberSlice';
import { NAVIGATION } from '../../lib/navigation';
import { useNavigate } from 'react-router-dom';

const TeamMemberForm = ({
    defaultData,
}) => {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const navigate = useNavigate();

    const defaultValues = {
        teamMemberName: defaultData?.team_member_name ?? "",
        designation: defaultData?.team_member_designation ?? "",
        twitterUrl: defaultData?.twitter_url ?? "",
        linkedInUrl: defaultData?.linkedIn_url ?? "",
        facebookUrl: defaultData?.facebook_url ?? "",
        instagramUrl: defaultData?.instagram_url ?? "",
    }

    const afterAPICall = (response) => {
        dispatch(setSelectedTeamMember(null))
        navigate(NAVIGATION.INNER_NAVIGATION.MASTERS.TEAM_MEMBERS)

    }

    const beforeAPICall = (data) => {
        const formData = new FormData();
        formData.append('teamMemberName', data?.teamMemberName);
        formData.append('designation', data?.designation);
        formData.append('twitterUrl', data?.twitterUrl);
        formData.append('linkedInUrl', data?.linkedInUrl);
        formData.append('facebookUrl', data?.facebookUrl);
        formData.append('instagramUrl', data?.instagramUrl);
        if (file) {
            formData.append('profileImage', file);
        }
        return {
            success: true,
            refactoredData: {
                formData,
                query: {
                    teamMemberId: defaultData?.team_member_id ?? "",
                },
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateTeamMember : createTeamMember,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('teamMemberName', defaultData?.team_member_name ?? "");
            setValue('designation', defaultData?.team_member_designation ?? "");
            setValue('twitterUrl', defaultData?.twitter_url ?? "");
            setValue('linkedInUrl', defaultData?.linkedIn_url ?? "");
            setValue('facebookUrl', defaultData?.facebook_url ?? "");
            setValue('instagramUrl', defaultData?.instagram_url ?? "");
        } else {
            setValue('teamMemberName', "");
            setValue('designation', "");
            setValue('twitterUrl', "");
            setValue('linkedInUrl', "");
            setValue('facebookUrl', "");
            setValue('instagramUrl', "");
        }
    }, [defaultData, setValue]);
    return (
        <form onSubmit={handleSubmit}>
            <div className='flex gap-0 md:gap-6 flex-col md:flex-row'>
                <Input
                    control={control}
                    name="teamMemberName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="name"
                />
                <Input
                    control={control}
                    name="designation"
                    rules={{
                        required: "this field is required"
                    }}
                    label="designation"
                />
            </div>
            <Input
                control={control}
                type='file'
                name="logo"
                onChange={(event) => { setFile(event.target.files ? event.target.files[0] : null) }}
                label="logo"
            />
            <div className='flex gap-0 md:gap-6 flex-col md:flex-row'>
                <Input
                    control={control}
                    name="twitterUrl"
                    label="twitter Url"
                    rules={{
                        required: "this field is required"
                    }}
                />
                <Input
                    control={control}
                    name="linkedInUrl"
                    label="linkedIn Url"
                    rules={{
                        required: "this field is required"
                    }}
                />
                <Input
                    control={control}
                    name="facebookUrl"
                    label="facebook Url"
                    rules={{
                        required: "this field is required"
                    }}
                />
                <Input
                    control={control}
                    name="instagramUrl"
                    label="Instagram Url"
                    rules={{
                        required: "this field is required"
                    }}
                />
            </div>


            <div className="flex justify-end my-6">
                <Button isLoading={isLoading}>
                    {defaultData ? "Save changes" : "Submit"}
                </Button>
            </div>
        </form>
    )
}

export default TeamMemberForm